import { useQuery } from "@tanstack/react-query";
import { getHomeHeaderSection } from "../../api/apiHomeHeader";

export const useGetHomeHeaderSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["home-header-section"],
        queryFn: getHomeHeaderSection,
    });

    return {
        homeHeaderSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
